module.exports = __webpack_public_path__ + "img/productBgImg15.104ec735.png";